import React, { Component } from "react";

import {
  Platform,
  View,
  TouchableHighlight,
  ScrollView,
  StyleSheet,
} from "react-native";
import Text from "../../components_v2/TextFont";
import { SimpleIcon } from "../../components_v2/Buttons";
import * as faCharCodes from "../../../assets/consts/faCharCodes";
import * as SecureStore from "../../components_v2/DeviceAsyncStorage";
import { translate } from "../../locales/translate";

import arTheme from "../../argon-ui/Theme";

import * as CONSTS from "../../../assets/consts";
import { connect } from "react-redux";
import Loading from "../../components/Loading";
import { getIsRTL } from "../../util";

let appSettings = require("../../../app.json");
const api_LatestUpdates = "Info/LatestUpdates";

class UpdateScreen extends Component {
  constructor(props) {
    super(props);

    // let { hasNewUpdate } = this.props.navigation.state.params;
    this.state = {
      serverIP: "",
      isShowingLogoutAlert: false,
      newUpdateDetails: undefined,
      latestUpdatesDetail: [],
      currentVersion: appSettings.expo.version,
      availableVersion: undefined,
      isFetchingNewUpdateDetails: true,
      isFetchingLatestUpdatesDetail: true,
      // hasNewUpdate,
    };
  }
  static navigationOptions = ({ screenProps: { translate } }) => ({
    headerTitle: translate("navigation.Setting"),
  });
  async componentDidMount() {
    var serverUrl = await SecureStore.getItemAsync(CONSTS.SERVER_URL);
    this.setState({ serverUrl }, () => {
      this.getUpdatesHistory();
    });
  }

  getUpdatesHistory = () => {
    let { serverUrl } = this.state;
    if (serverUrl) {
      if (!serverUrl.endsWith("/")) {
        serverUrl = serverUrl + "/";
      }
      var apiUrl = `${serverUrl}${api_LatestUpdates}?platform=${Platform.OS}`;
      fetch(apiUrl, {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          return res.json();
        })
        .then((resJ) => {
          if (resJ.successful) {
            this.setState({
              latestUpdatesDetail: resJ.summaries,
              isFetchingLatestUpdatesDetail: false,
            });
          } else {
            this.setState({ isFetchingLatestUpdatesDetail: false });
          }
        })
        .catch((e) => {
          console.log(e);
          this.setState({ isFetchingLatestUpdatesDetail: false });
        });
    } else {
      this.setState({ isFetchingLatestUpdatesDetail: false });
    }
  };

  render() {
    // show waiting
    if (this.state.isFetchingLatestUpdatesDetail) {
      return <Loading />;
    }

    // show data
    var updateHistory = [];
    if (this.state.latestUpdatesDetail.length > 0) {
      updateHistory = this.state.latestUpdatesDetail.filter(
        (uh) =>
          !this.state.newUpdateDetails ||
          uh.version != this.state.newUpdateDetails.version
      );
    }
    return (
      <View style={{ flex: 1 }}>
        <Text style={styles.updateHistoryTitle}>
          {translate("settings.updatesHistory")}
        </Text>

        {updateHistory.length > 0 && (
          <View style={{ flex: 1, backgroundColor: "#f2f2f2" }}>
            <ScrollView>
              {updateHistory.map((item, idx) => {
                return (
                  <UpdateCard
                    isCurrent={item.version == this.state.currentVersion}
                    isExpanded={
                      this.state.newUpdateDetails == undefined && idx == 0 // if there is no new update, expand first item
                    }
                    model={item}
                    key={idx}
                  />
                );
              })}
            </ScrollView>
          </View>
        )}
      </View>
    );
  }
}

class UpdateCard extends Component {
  constructor(props) {
    super(props);

    let { isNew, isExpanded, isCurrent, model } = this.props;
    this.state = {
      isExpanded: isNew || isExpanded || false,
    };
  }

  handleOnExpandPress = () => {
    this.setState({ isExpanded: true });
  };

  handleOnDownloadNewPress = () => {
    typeof this.props.onDownloadNewPress === "function" &&
      this.props.onDownloadNewPress();
  };

  renderList = (title, items) => {
    if (items && items.length > 0) {
      return (
        <View style={styles.updateSubSection}>
          <Text style={styles.title}>{title}</Text>
          {items.map((item, idx) => {
            return (
              <Text style={styles.item} key={idx}>
                - {item}
              </Text>
            );
          })}
        </View>
      );
    }
    return null;
  };

  render() {
    return (
      <View
        style={[
          styles.wrapper,
          this.props.isNew ? styles.newUpdateWrapper : {},
        ]}
      >
        <View style={styles.versionWrapper}>
          <Text style={styles.version}>{this.props.model.version}</Text>
          {this.props.isNew === true && (
            <TouchableHighlight
              style={styles.btnInstall}
              onPress={this.handleOnDownloadNewPress}
            >
              <Text style={styles.btnInstallText}>
                {translate("settings.installUpdate")}{" "}
                <SimpleIcon
                  color="#FFF"
                  icon={faCharCodes.faCloudDownload}
                  fontFamily={faCharCodes.FONT_FAMILIES.PRO_REGULAR}
                  size={14}
                />
              </Text>
            </TouchableHighlight>
          )}
          {!this.state.isExpanded && (
            <TouchableHighlight onPress={this.handleOnExpandPress}>
              <Text style={{ color: arTheme.COLORS.ACTIVE }}>
                {translate("app.more")}{" "}
                <SimpleIcon
                  color={arTheme.COLORS.ACTIVE}
                  icon={faCharCodes.faAngleDoubleDown}
                  size={14}
                />
              </Text>
            </TouchableHighlight>
          )}
        </View>
        {this.props.isCurrent && (
          <Text style={styles.versionBadge}>
            {translate("settings.isCurrentVersion")}
          </Text>
        )}
        {this.props.isNew && (
          <Text style={[styles.versionBadge, styles.notInstalledBadge]}>
            {translate("settings.notInstalledYet")}
          </Text>
        )}
        {this.state.isExpanded && (
          <View>
            {this.renderList(
              translate("settings.newFeatures"),
              this.props.model.newFeatures
            )}
            {this.renderList(
              translate("settings.enhancements"),
              this.props.model.enhancements
            )}
            {this.renderList(
              translate("settings.bugsFixed"),
              this.props.model.bugsFixed
            )}
          </View>
        )}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  wrapper: {
    paddingHorizontal: 15,
    paddingVertical: 8,
    // paddingTop: 5,
    margin: 10,
    borderColor: arTheme.COLORS.BORDER,
    borderWidth: 1,
    borderRadius: 10,
  },
  newUpdateWrapper: {
    backgroundColor: arTheme.COLORS.TL_YELLOW,
    shadowColor: arTheme.COLORS.WARNING,
    shadowOffset: { height: -5, width: -2 },
    elevation: 3,
  },
  updateButtonWrapper: { flexDirection: "row", justifyContent: "center" },
  currentVersionWrapper: {},
  versionBadge: {
    fontSize: 11,
    fontStyle: "italic",
    backgroundColor: "#999",
    borderRadius: 5,
    padding: 2,
    width: 64,
    textAlign: "center",
  },
  notInstalledBadge: {
    backgroundColor: "#F00",
    width: 90,
  },
  version: {
    textAlign: getIsRTL() ? "left" : "right",
    fontSize: 42,
    fontWeight: "bold",
    //marginBottom: 10,
  },
  versionWrapper: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  updateHistoryTitle: {
    fontSize: 28,
    marginEnd: 15,
    marginTop: 16,
    marginBottom: 8,
  },
  updateSubSection: {},
  title: { fontSize: 18, fontWeight: "bold", marginTop: 10 },
  item: { paddingStart: 10 },
  btnInstall: {
    borderColor: arTheme.COLORS.WARNING,
    borderWidth: 1,
    borderRadius: 3,
    padding: 3,
    height: 36,
    width: 130,
    shadowColor: "#000",
    shadowOpacity: 0.8,
    shadowRadius: 3,
    elevation: 2,
    shadowOffset: { height: 3, width: 3 },
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f89c87",
  },
  btnInstallText: {
    color: "#FFF",
    fontSize: 14,
  },
});

const mapStateToProps = (state) => {
  return {
    // appReducer: state.AppReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // ResetConnection: (newServerUrl) =>
    //   dispatch(AppActions.ResetConnection(newServerUrl)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateScreen);
